import DesignTable from './components/design'

const components = [
    DesignTable
]
function install(Vue){
    components.forEach(component => {
        Vue.component(component.name,component)
    });
}

export {
    DesignTable,
    install
}

export default install


// WEBPACK FOOTER //
// ./src/components/report/index.js